/**
 * Clerk Configuration - Clean Implementation
 * Configuración profesional de Clerk para multitenancy
 */

export const clerkConfig = {
  // Publishable key - Lección aprendida: React usa REACT_APP_*
  publishableKey: process.env.REACT_APP_CLERK_PUBLISHABLE_KEY,

  // Verificar si está configurado
  isConfigured() {
    return !!this.publishableKey;
  },

  // Obtener clave con validación
  getPublishableKey() {
    if (!this.publishableKey) {
      throw new Error(
        'Clerk publishable key is missing. Please set REACT_APP_CLERK_PUBLISHABLE_KEY in your environment variables.'
      );
    }
    return this.publishableKey;
  },

  // Configuración de apariencia profesional para Shakkii
  appearance: {
    layout: {
      logoImageUrl: '/shakkii logo multicolor.jpeg',
      logoPlacement: 'outside', // Cambiar a outside para que aparezca fuera del modal
      socialButtonsPlacement: 'bottom',
      showOptionalFields: true,
    },
    variables: {
      colorPrimary: '#4F81E7',
      colorBackground: '#ffffff',
      colorInputBackground: '#ffffff',
      colorInputText: '#333333',
      fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      fontWeight: {
        normal: 400,
        medium: 500,
        semibold: 600,
        bold: 700,
      },
      borderRadius: '8px',
    },
    elements: {
      // Botones principales
      formButtonPrimary: {
        fontSize: '16px',
        fontWeight: '600',
        backgroundColor: '#4F81E7',
        borderRadius: '8px',
        border: 'none',
        padding: '12px 24px',
        textTransform: 'none',
        '&:hover': {
          backgroundColor: '#3D6FD9',
        },
      },

      // Card principal
      card: {
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
        border: '1px solid #e5e7eb',
        borderRadius: '12px',
        backgroundColor: '#ffffff',
      },

      // Header con logo
      headerTitle: {
        fontSize: '24px',
        fontWeight: '700',
        color: '#1f2937',
        marginBottom: '8px',
      },

      headerSubtitle: {
        fontSize: '16px',
        color: '#6b7280',
        marginBottom: '24px',
      },

      // Campos de entrada
      formFieldInput: {
        borderRadius: '8px',
        border: '1px solid #d1d5db',
        padding: '12px 16px',
        fontSize: '16px',
        backgroundColor: '#ffffff',
        '&:focus': {
          borderColor: '#4F81E7',
          boxShadow: '0 0 0 3px rgba(79, 129, 231, 0.1)',
          outline: 'none',
        },
      },

      // Labels
      formFieldLabel: {
        fontSize: '14px',
        fontWeight: '500',
        color: '#374151',
        marginBottom: '6px',
      },

      // Links
      footerActionLink: {
        color: '#4F81E7',
        fontWeight: '500',
        textDecoration: 'none',
        '&:hover': {
          textDecoration: 'underline',
          color: '#3D6FD9',
        },
      },

      // Botones sociales
      socialButtonsBlockButton: {
        borderRadius: '8px',
        border: '1px solid #d1d5db',
        backgroundColor: '#ffffff',
        color: '#374151',
        fontSize: '14px',
        fontWeight: '500',
        '&:hover': {
          backgroundColor: '#f9fafb',
          borderColor: '#9ca3af',
        },
      },

      // Divider
      dividerLine: {
        backgroundColor: '#e5e7eb',
        height: '1px',
      },

      dividerText: {
        color: '#6b7280',
        fontSize: '14px',
      },

      // Logo personalizado en esquina superior izquierda de toda la página
      rootBox: {
        position: 'relative',
        '&::before': {
          content: '""',
          position: 'fixed',
          top: '20px',
          left: '20px',
          width: '150px',
          height: '50px',
          backgroundImage: 'url(/shakkii logo multicolor.jpeg)',
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'left center',
          zIndex: 9999,
          pointerEvents: 'none',
        },
      },

      // Asegurar que el body también tenga el logo
      body: {
        position: 'relative',
        '&::before': {
          content: '""',
          position: 'fixed',
          top: '20px',
          left: '20px',
          width: '150px',
          height: '50px',
          backgroundImage: 'url(/shakkii logo multicolor.jpeg)',
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'left center',
          zIndex: 9999,
          pointerEvents: 'none',
        },
      },
    },
  },

  // Configuración de organizaciones
  organizationSettings: {
    enabled: true,
    allowUserToCreateOrganizations: true,
    showOrganizationSwitcher: true,
  },

  // URLs de redirección
  redirectUrls: {
    signIn: '/',
    signUp: '/',
    afterSignIn: '/',
    afterSignUp: '/',
  },
};

export default clerkConfig;
